/**
 * Hero section -- Swiper init (csak akkor, ha 2+ slide van).
 *
 * Defer-betöltés miatt a DOMContentLoaded-re kell várni: a main.min.js
 * a swiper-bundle.min.js ELŐTT fut le a HTML sorrendben, így ha az IIFE
 * azonnal futna, `window.Swiper` még undefined lenne.
 */
(function () {
  'use strict';

  function init() {
    var SwiperLib = window.Swiper;
    if (!SwiperLib) { return; }

    var heroes = document.querySelectorAll('.hero .hero__swiper');
    if (!heroes.length) { return; }

    heroes.forEach(function (el) {
      var sectionEl = el.closest('.hero');
      var autoplay  = sectionEl && sectionEl.getAttribute('data-autoplay') === '1';
      var delay     = sectionEl ? (parseInt(sectionEl.getAttribute('data-delay'), 10) || 5000) : 5000;

      new SwiperLib(el, {
        loop: true,
        speed: 700,
        effect: 'slide',
        autoplay: autoplay ? { delay: delay, disableOnInteraction: false, pauseOnMouseEnter: true } : false,
        pagination: {
          el: sectionEl ? sectionEl.querySelector('.hero__pagination') : null,
          clickable: true,
        },
        navigation: {
          prevEl: sectionEl ? sectionEl.querySelector('.hero__nav--prev') : null,
          nextEl: sectionEl ? sectionEl.querySelector('.hero__nav--next') : null,
        },
      });
    });
  }

  if (document.readyState === 'complete') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
